module.exports = __webpack_public_path__ + "static/media/phone.cecc542.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Smena7/phone.mp4
// module id = 0JSs
// module chunks = 1